import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hotel-list__headline"
}
const _hoisted_2 = {
  key: 1,
  class: "hotel-list"
}
const _hoisted_3 = { class: "hotel-list__aside" }
const _hoisted_4 = { class: "hotel-list__content" }
const _hoisted_5 = { class: "hotel-list__list" }
const _hoisted_6 = { class: "hotel-list__top-container" }
const _hoisted_7 = {
  key: 0,
  class: "hotel-list__count-hotels--dropdown"
}
const _hoisted_8 = { class: "hotel-list__count-number" }
const _hoisted_9 = {
  key: 0,
  class: "hotel-list__count-text"
}
const _hoisted_10 = {
  key: 1,
  class: "hotel-list__load-box"
}
const _hoisted_11 = { class: "hotel-list__pager" }
const _hoisted_12 = {
  key: 0,
  class: "hotel-list__print-footer"
}

import NoOffersFound from '@lmt-rpb/NoOffersFound/NoOffersFound.vue';
import HotelListItemList from '@lmt-rpb/HotelListItemList/HotelListItemList.vue';
import type { AxiosError } from 'axios';
import axios from 'axios';
import DropdownHotelFilter from '@lmt-rpb/DropdownHotelFilter/DropdownHotelFilter.vue';
import type { SearchFormDataType } from '@interfaces/search-form';
import { getAll as getAllParams } from '@components/common/services/url';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { scrollIt } from '@utils/utils';
import { isClientGermany } from '@utils/environmentUtils';
import { API_URLS, GOOGLE_MAPS_API_KEY, HOTEL_LIST_PAGE_SIZE } from '@global-js/constants';
import ListPageSearch from '@lmt-rpb/ListPageSearch/ListPageSearch.vue';
import ListFilters from '@lmt-rpb/ListFilters/ListFilters.vue';
import FilterTagList from '@lmt-rpb/FilterTagList/FilterTagList.vue';
import { updateBreadcrumbUrl } from '@modules/updateUrls';
import { EventBus } from '@global-js/event-bus';
import { computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, type Ref, ref, watch } from 'vue';
import type { ItemType, _links } from '@interfaces/hotel-list-types/hotel-list-types';
import * as searchHistoryService from '@components/common/services/localStorage/searchHistoryService';
import { createDiscountRequest, getAsMap as fetchDiscountData } from '@components/common/services/neustaService';
import { fetchTourOperatorInventory } from '@/components/common/services/tourOperatorInventoryService';
import type { HotelListData } from '@/interfaces/components/hotelListData';
import { useStore } from '@/components/common/store';
import { mergeMaps } from '@/js/utils/objectUtils';
import type { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';
import QuickPillHotelList from '@components/QuickPillHotelList/QuickPillHotelList.vue';
import type { ApiDataTypesKeys } from '../common/types';
import { getDiscountHotelPriceOfferMap } from './helpers';
import { getHotelListOffer, NO_RESPONSE_OR_EMPTY_RESPONSE } from '@services/bestOfferForHotelListService';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import MapPreviewAndModal from '@lmt-rpb/MapPreviewAndModal/MapPreviewAndModal.vue';
import HotelMap from '@lmt-rpb/Molecules/HotelMap/HotelMap.vue';
import { fetchGeoInventory } from '@services/geoInventoryService';
import type { BaseOfferForHotelListResponse } from '@interfaces/common';
import { useFilters } from 'src/composables/useFIlters';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';
import { isPrintPreview } from '@helper/composables/printPreview';
import type { SearchBestOfferForHotelResponse } from '@interfaces/api/search-best-offer-hotel';
import { formatDate } from '@utils/dateTimeUtils';
import { useTranslations } from '@helper/composables/translations';
import PrintHeader from '@lmt-rpb-new/molecules/PrintHeader/PrintHeader.vue';
import { SHOP_INFO_KEY } from '@interfaces/localStorage/shop-info';
import type { ShopInfo } from '@interfaces/localStorage/shop-info';
// TODO: import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import PaginationNavigation from '@lmt-rpb-new/molecules/PaginationNavigation/PaginationNavigation.vue';
import { useSelectedDestination } from 'src/composables/useSelectedDestination';
import { usePagination } from 'src/composables/usePagination';


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelList',
  setup(__props) {

const store = useStore();
const { translate } = useTranslations();
const { printPreview } = isPrintPreview();

const formattedDate = computed(() =>
	formatDate(new Date(), {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	})
);

const printHeaderData = computed(() => {
	// In case no localStorage is set, null is returned
	const storageRes = window.localStorage.getItem(SHOP_INFO_KEY);
	return storageRes ? (JSON.parse(storageRes) as ShopInfo) : null;
});

const listPageSearch = ref<InstanceType<typeof ListPageSearch>>();
const quickPillHotelList = ref<InstanceType<typeof QuickPillHotelList>>();
const items = ref<ItemType[]>([]);
const discounts: Ref<Map<string, DiscountHotelPriceOffer>> = ref(new Map());
const links = ref<_links>({});
const error = ref<AxiosError | null>(null);
const hotelListData = ref<HotelListData>(document.getElementById('hotel-list-data')?.dataset as unknown as HotelListData);

const serverSideHotelListResponse: SearchBestOfferForHotelResponse | null = JSON.parse(hotelListData.value.serverSideHotelListResponse);

const loading = ref(true);
const ratingAttributes = ref('');
const storeInitialized = ref(store.state.config.storeInitialized);
const formData = computed((): SearchFormDataType => store.state.searchMask);
const savedFormData = ref<SearchFormDataType>({ ...formData.value }); // Copy of formData
const hasDealsFilterActive = computed(() => store.getters['searchMask/hasDealsFilter']);

const { selectedDestinationCountLabel: selectedDestinationCount } = useSelectedDestination();

const apiData = store.getters['searchMask/apiData'];

const { isDesktop } = storeToRefs(useBreakpointStore());

const locationIdName = computed((): 'RegionID' | 'CityID' => {
	const locationTypeId = hotelListData.value?.locationType;
	return locationTypeId === 'COUNTRY' || locationTypeId === 'REGIONGROUP' ? 'RegionID' : 'CityID';
});

const name = computed((): string | undefined => hotelListData.value?.destinationName);

const showSuns = isClientGermany();

const { filtersCount } = useFilters();

const hasResults = computed((): boolean => {
	return items.value.length > 0;
});

let isFirstFetch = true;

// save list before navigating away
const rememberHotelListItems = (): void => {
	const sessionArray = [Date.now(), window.scrollY, items.value, links.value, Array.from(discounts.value.entries())];

	try {
		sessionStorage.setItem(window.location.href, JSON.stringify(sessionArray));
	} catch (errorSaveList) {
		console.log(errorSaveList);
	}
};

const handleMapOpenAnalytics = () => {
	SelectContentAnalytics.selectContent({
		cType: 'ux_hotellist_click',
		cId: 'hotellistmap',
	});
};

const handleMapOfferLinkOpened = () => {
	SelectContentAnalytics.selectContent({
		cId: 'split_view_mapofferbox',
		cType: 'ux_hotellist_click',
	});
};

const geoBoundaries = computed(() => {
	try {
		return JSON.parse(hotelListData?.value?.geoBoundaries);
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch (_error) {
		return null;
	}
});

const sortingParamWasChanged = (): boolean => formData.value.sortingHotel !== savedFormData.value.sortingHotel;

const formDataWasChanged = (): boolean => {
	// Excludes for offerlist update
	/* eslint-disable @typescript-eslint/no-unused-vars */
	const {
		destination: currentDestination,
		searchTerm: currentSearchTerm,
		modified: currentModified,
		availableHotelCount: currentAvailableHotelCount,
		selectedGeoInventory: currentSelectedGeoInventory,
		destinationTypes: currentDestinationTypes,
		destinationTypeName: currentDestinationTypeName,
		maxTravelDurationError: currentError,
		...newFormData
	} = formData.value;
	const {
		destination: savedDestination,
		searchTerm: savedtSearchTerm,
		modified: savedModified,
		availableHotelCount: savedAvailableHotelCount,
		selectedGeoInventory: savedSelectedGeoInventory,
		destinationTypes: savedDestinationTypes,
		destinationTypeName: savedDestinationTypeName,
		maxTravelDurationError: savedError,
		...newSavedFormData
	} = savedFormData.value;
	/* eslint-enable @typescript-eslint/no-unused-vars */

	// Update savedFormData
	savedFormData.value = { ...formData.value };

	if (newFormData.additionalCheckboxFilters?.ratingAttributes) {
		const newRatingAttributes = JSON.stringify(
			newFormData.mostPopularFilters?.ratingAttributes?.concat(newFormData.additionalCheckboxFilters?.ratingAttributes)
		);
		// Check if wanted fields updated
		if (newRatingAttributes !== ratingAttributes.value) {
			ratingAttributes.value = newRatingAttributes;
			return true;
		}
	}

	return JSON.stringify(newFormData) !== JSON.stringify(newSavedFormData);
};

const handlePopState = ({ state }: PopStateEvent): void => {
	EventBus.$emit('window:popstate', state);
};

const handleKeydown = ({ which }: KeyboardEvent): void => {
	const meta = (
		{
			27: 'esc',
		} as { [key: number]: string }
	)[which];

	if (meta) {
		EventBus.$emit(`keydown.${meta}`);
	}
};

const fetchTourOperators = (): void => {
	const listType = hotelListData.value?.locationType;
	const exclude: ApiDataTypesKeys[] = [];

	exclude.push('HotelIffCode');

	if (listType === 'COUNTRY') {
		exclude.push('Regions', 'Cities');
	}
	if (listType === 'REGIONGROUP') {
		exclude.push('Cities');
	}

	const bodyParams = {
		regionGroupIds: listType === 'REGIONGROUP' && hotelListData.value.rlId ? [parseInt(hotelListData.value.rlId, 10)] : [],
		locationId: listType === 'COUNTRY' ? [hotelListData.value.locationId] : [],
		rid: listType === 'TOPREGION' ? [parseInt(hotelListData.value.rid, 10)] : [],
		cyid: listType === 'CITY' ? [parseInt(hotelListData.value.cyid, 10)] : [],
	};

	fetchTourOperatorInventory(bodyParams, exclude);
};

const scrollTop = (): void => {
	SelectContentAnalytics.selectContent({
		cId: 'scroll_to_top',
		cType: 'ux_hotellist_click',
	});

	scrollIt(0, 1000, 'easeOutQuad');
};

function openSearch() {
	if (!isDesktop.value) {
		listPageSearch.value!.searchFormModal!.openModal();
	}
}

function openFilters() {
	if (!isDesktop.value) {
		listPageSearch.value!.filterModal!.openModal();
	}
}

function createFetchRequest() {
	const listType: string | undefined = hotelListData.value.locationType;
	const travelType = formData.value.onlyHotel ? 'Accommodation' : 'Package';
	const exclude: ApiDataTypesKeys[] = travelType === 'Accommodation' ? ['DepartureAirport', 'DirectFlight', 'Transfer'] : [];
	exclude.push('DefiniteStartDate', 'HotelIffCode');

	// destinationTypes can be either Regions or Cities
	// so we remove the Cities param here or else Cities & Regions will use the same id
	if (listType === 'COUNTRY') {
		exclude.push('Cities');
	}
	if (listType === 'CITY') {
		exclude.push('Regions');
	}
	if (listType === 'REGIONGROUP') {
		exclude.push('Cities');
	}

	const bodyParams: Partial<SearchFormDataType> = {
		regionGroupIds: listType === 'REGIONGROUP' && hotelListData.value.rlId ? [parseInt(hotelListData.value.rlId, 10)] : [],
		locationId: listType === 'COUNTRY' ? [hotelListData.value.locationId] : [],
		rid: listType === 'TOPREGION' && hotelListData.value.rid ? [parseInt(hotelListData.value.rid, 10)] : [],
		cyid: listType === 'CITY' && hotelListData.value.cyid ? [parseInt(hotelListData.value.cyid, 10)] : [],
		numberOfResults: HOTEL_LIST_PAGE_SIZE,
	};
	return apiData(bodyParams, exclude);
}

// refs #12905 temporarily disable neusta for offers with infants
const discountsWithoutInfants = computed(() => {
	const discountsLocal = discounts.value;
	const lastRequestHasInfant = lastFetchRequestBody.value.Children?.some((age) => age === 1);

	return lastRequestHasInfant ? undefined : discountsLocal;
});

const lastFetchRequestBody = computed(() => {
	const body = createFetchRequest();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { Cities, Regions, ...mapRequestBody } = body;

	return mapRequestBody;
});

async function fetchItems(url?: string): Promise<BaseOfferForHotelListResponse<ItemType>> {
	const body = createFetchRequest();
	const apiUrl = url || API_URLS.HOTEL_LIST;
	if (JSON.stringify(body.Cities) === JSON.stringify(body.Regions)) {
		body.Cities = '';
	}

	try {
		const response = await getHotelListOffer(String(apiUrl), body, 'hotelListOffers');
		// remove error if any
		error.value = null;
		try {
			sessionStorage.lastfetch = Date.now();
		} catch (errorStorageDate) {
			console.log(errorStorageDate);
		}
		return response;
	} catch (axiosError) {
		const { response } = axiosError as AxiosError;
		if (response && response.status >= 500) {
			error.value = axiosError as AxiosError;
		} else {
			items.value = [];
		}

		throw axiosError;
	}
}

async function getDiscounts(offerItems: ItemType[]) {
	let newItemDiscounts: Map<string, DiscountHotelPriceOffer>;
	const discountRequest = createDiscountRequest(
		offerItems,
		store.state.searchMask.travelers.adult,
		store.state.searchMask.travelers.children
	);
	if (hasDealsFilterActive.value || formData.value.sortingHotel === 'Discount') {
		newItemDiscounts = getDiscountHotelPriceOfferMap(discountRequest as ItemType[]);
	} else {
		newItemDiscounts = await fetchDiscountData(discountRequest);
	}
	if (discounts.value.size === 0) {
		discounts.value = newItemDiscounts;
	} else {
		discounts.value = mergeMaps(discounts.value, newItemDiscounts);
	}
}

const fetchItemsClient = async (link?: _links[keyof _links]): Promise<void> => {
	try {
		const resp = await fetchItems(link);
		// validate response
		if (!resp || !resp.Offers || Array.isArray(resp)) {
			items.value = [];
			links.value = {};
			page.value = 1;

			return;
		}

		if (resp.Offers.length === 0 && page.value !== 1) {
			await navigateFirst();
		} else {
			items.value = resp.Offers;
			links.value = resp._links ?? {};
			getDiscounts(resp.Offers);
		}
	} catch (err) {
		items.value = [];
		links.value = {};
		page.value = 1;
		throw err;
	}
};

const getItems = async (): Promise<void> => {
	loading.value = true;

	// Set server side response if available
	const params = window.location.search;
	if (isFirstFetch && serverSideHotelListResponse && !params.length) {
		items.value = serverSideHotelListResponse.Offers as ItemType[];
		links.value = serverSideHotelListResponse._links ? serverSideHotelListResponse._links : {};
		loading.value = false;
		try {
			await getDiscounts(items.value);
		} catch (requestError) {
			console.error('HotelList: ', requestError);
		}
	} else {
		try {
			await fetchItemsClient(`${API_URLS.HOTEL_LIST}?page=${page.value}`);
			loading.value = false;
		} catch (axiosError) {
			if (axios.isCancel(axiosError)) {
				loading.value = true;
			} else if ((axiosError as Error).message === NO_RESPONSE_OR_EMPTY_RESPONSE) {
				loading.value = false;
			} else {
				loading.value = false;
				console.error('HotelList: ', axiosError);
			}
		} finally {
			if (items.value.length === 0 && page.value !== 1) {
				await navigateFirst();
			}
		}
	}
	isFirstFetch = false;
	await fetchGeoInventory(hotelListData, formData.value.onlyHotel, locationIdName);
};

const handleMobileSubmit = (): void => {
	if (!isDesktop.value && formDataWasChanged()) {
		searchHistoryService.update();
		page.value = 1;
		updatePageUrl();

		loading.value = true;

		getItems();
		fetchTourOperators();
		quickPillHotelList.value?.loadMostPopularPlaces();
	}
};

const getMoreItems = async (link: _links[keyof _links]): Promise<void> => {
	// set loading true
	loading.value = true;
	try {
		await fetchItemsClient(link);
	} catch (requestError) {
		const { response } = requestError as AxiosError;

		if (response && response.status >= 500) {
			error.value = requestError as AxiosError;
		}
		console.error('HotelList: ', requestError);
	} finally {
		loading.value = false;
	}
};

const { navigateForward, navigateBack, navigateFirst, page, hasNext, updatePageUrl } = usePagination(links, getMoreItems);

const showPagination = computed(() => {
	if (loading.value) return false;
	if (!links.value.next && !links.value.prev) return false;
	return true;
});

const handleNext = () => {
	SelectContentAnalytics.selectContent({
		cId: 'pagination_to_next',
		cType: 'ux_hotellist_load_more',
		index: page.value + 1,
	});
	document.body.scrollIntoView({ behavior: 'instant' });
	return navigateForward();
};

const handlePrev = () => {
	SelectContentAnalytics.selectContent({
		cId: 'pagination_to_previous',
		cType: 'ux_hotellist_load_more',
		index: page.value - 1,
	});
	document.body.scrollIntoView({ behavior: 'instant' });
	return navigateBack();
};

const handleFirst = () => {
	SelectContentAnalytics.selectContent({
		cId: 'pagination_to_first',
		cType: 'ux_hotellist_load_more',
		index: 1,
	});
	document.body.scrollIntoView({ behavior: 'instant' });
	return navigateFirst();
};

watch(formData.value, () => {
	if (!isDesktop.value && !sortingParamWasChanged()) {
		return;
	}

	if (formDataWasChanged()) {
		searchHistoryService.update();
		page.value = 1;
		updatePageUrl();
		getItems();
		quickPillHotelList.value?.loadMostPopularPlaces();
	}
});

// life cycle events
onBeforeMount((): void => {
	// set window event listeners
	window.addEventListener('popstate', handlePopState);

	// set keydown listener
	document.addEventListener('keydown', handleKeydown);

	// update query params if page is loaded with params
	const params = getAllParams();
	if (Object.keys(params).length) {
		updatePageUrl(params?.page ?? '1');
	}

	window.addEventListener('pagehide', rememberHotelListItems.bind(this));
});

onMounted((): void => {
	addThemeMiniMarginClass();
	if (formData.value.additionalCheckboxFilters?.ratingAttributes) {
		ratingAttributes.value = JSON.stringify(
			formData.value.mostPopularFilters?.ratingAttributes?.concat(formData.value.additionalCheckboxFilters?.ratingAttributes)
		);
	}

	// Detect if this is a page reload vs back/forward navigation (bf cache for desktop)! mobile will be handled by the browser self
	const pageReloaded = performance.getEntriesByType('navigation')[0]?.type === 'reload';

	try {
		const oneHourInMs = 3600000;
		const lastSessionArray = JSON.parse(sessionStorage.getItem(window.location.href) as string);
		if (lastSessionArray && Date.now() < lastSessionArray[0] + oneHourInMs && !pageReloaded) {
			fetchGeoInventory(hotelListData, formData.value.onlyHotel, locationIdName);
			items.value = lastSessionArray[2];
			loading.value = false;
			links.value = lastSessionArray[3] || {};
			discounts.value = new Map(lastSessionArray[4]);
			nextTick(() => window.scrollTo(0, lastSessionArray[1]));
		} else {
			getItems();
		}
	} catch {
		getItems();
	}

	fetchTourOperators();

	EventBus.$on('SearchMask:MobileSubmit', handleMobileSubmit);
	EventBus.$on('mapOfferButtonLinkOpened', handleMapOfferLinkOpened);

	// Update breadcrumb URLs
	EventBus.$on('url:change', updateBreadcrumbUrl);
	// Initial update of URLs
	updateBreadcrumbUrl();
});

onBeforeUnmount((): void => {
	window.removeEventListener('popstate', handlePopState);
	document.removeEventListener('keydown', handleKeydown);
	EventBus.$off('SearchMask:MobileSubmit', handleMobileSubmit);
	EventBus.$off('mapOfferButtonLinkOpened', handleMapOfferLinkOpened);
	EventBus.$off('url:change', updateBreadcrumbUrl);

	window.removeEventListener('pagehide', rememberHotelListItems);
});

function addThemeMiniMarginClass() {
	document.body.classList.add('show-theme-mini-margin');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PrintHeader, _normalizeProps(_guardReactiveProps(printHeaderData.value)), null, 16 /* FULL_PROPS */),
    _createVNode(ListPageSearch, {
      ref_key: "listPageSearch",
      ref: listPageSearch,
      "mobile-teleport-target": "#list-page-search-container",
      "has-map": true,
      "has-sort": true,
      "list-type": "hotel",
      "destination-label": hotelListData.value.destinationName,
      "page-type": "hotellist"
    }, null, 8 /* PROPS */, ["destination-label"]),
    _createElementVNode("div", null, [
      (name.value)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(name.value) + " Hotels ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (storeInitialized.value)
        ? (_openBlock(), _createElementBlock("article", _hoisted_2, [
            _createElementVNode("aside", _hoisted_3, [
              _createVNode(MapPreviewAndModal, {
                id: "hotel-list-map",
                class: "hotel-list__section-google-maps",
                northwest: geoBoundaries.value.northwest,
                southeast: geoBoundaries.value.southeast,
                marker: true,
                "show-note": false,
                "default-offers": items.value,
                "maps-key": _unref(GOOGLE_MAPS_API_KEY),
                "hotel-request-body": lastFetchRequestBody.value,
                loading: loading.value,
                "show-search-bar": true,
                onOpenFilterModal: openFilters,
                onOpenSearchModal: openSearch
              }, {
                default: _withCtx(({ loadFullscreen }) => [
                  _createVNode(HotelMap, {
                    location: "",
                    onClickHotelMap: ($event: any) => {
								loadFullscreen();
								handleMapOpenAnalytics();
							}
                  }, null, 8 /* PROPS */, ["onClickHotelMap"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["northwest", "southeast", "default-offers", "maps-key", "hotel-request-body", "loading"]),
              _createVNode(ListFilters, {
                class: "hotel-list-filters",
                "list-type": 'hotel',
                "destination-label": name.value
              }, null, 8 /* PROPS */, ["destination-label"])
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(FilterTagList, {
                  "filter-number": _unref(filtersCount),
                  "has-results": hasResults.value,
                  "emit-analytics": _unref(isDesktop),
                  class: "hotel-list__filter-tag-list"
                }, null, 8 /* PROPS */, ["filter-number", "has-results", "emit-analytics"]),
                _createElementVNode("div", _hoisted_6, [
                  (hasResults.value && !loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(selectedDestinationCount)), 1 /* TEXT */),
                        (_unref(selectedDestinationCount))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "  gefunden"))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: _normalizeClass({
								'hotel-list__list-sort-filters': true,
								'hotel-list__list-sort-filters--no-results': !hasResults.value,
							})
                  }, [
                    (_unref(isDesktop))
                      ? (_openBlock(), _createBlock(DropdownHotelFilter, {
                          key: 0,
                          disabled: !hasResults.value
                        }, null, 8 /* PROPS */, ["disabled"]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ]),
                (!hasResults.value && !loading.value)
                  ? (_openBlock(), _createBlock(NoOffersFound, {
                      key: 0,
                      class: "hotel-list__no-results",
                      onOpenFilters: openFilters,
                      onOpenSearch: openSearch
                    }))
                  : _createCommentVNode("v-if", true),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(Loading, { class: "hotel-list__loader" })
                    ]))
                  : (_openBlock(), _createBlock(HotelListItemList, {
                      key: 2,
                      items: items.value,
                      class: "hotel-list__item-list",
                      loading: loading.value,
                      "show-suns": _unref(showSuns),
                      "hotel-list-type": hotelListData.value.locationType,
                      discounts: discountsWithoutInfants.value
                    }, null, 8 /* PROPS */, ["items", "loading", "show-suns", "hotel-list-type", "discounts"])),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode(PaginationNavigation, {
                    class: "hotel-list__pagination",
                    page: _unref(page),
                    "has-next": _unref(hasNext),
                    onPrev: handlePrev,
                    onNext: handleNext,
                    onToStart: handleFirst
                  }, null, 8 /* PROPS */, ["page", "has-next"]), [
                    [_vShow, showPagination.value]
                  ]),
                  (hasResults.value && !loading.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: "hotel-list__scroll-top",
                        "aria-label": "Scroll nach oben",
                        onClick: _withModifiers(scrollTop, ["prevent"])
                      }, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "hotel-list__scroll-top-label" }, "nach oben", -1 /* CACHED */)),
                        _createVNode(FaIcon, {
                          icon: ['fa-solid', 'fa-chevron-up'],
                          class: "hotel-list__scroll-top-icon"
                        })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _withDirectives(_createVNode(QuickPillHotelList, {
                  ref_key: "quickPillHotelList",
                  ref: quickPillHotelList,
                  "hotel-list-data": hotelListData.value,
                  class: "hotel-list__quick-pill-hotel-list"
                }, null, 8 /* PROPS */, ["hotel-list-data"]), [
                  [_vShow, !hasDealsFilterActive.value]
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", {
                  id: "adSlot",
                  class: "adSlot-container"
                }, null, -1 /* CACHED */))
              ])
            ]),
            (_unref(printPreview))
              ? (_openBlock(), _createElementBlock("footer", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_unref(translate)('hotelList.printDate') + ': ' + formattedDate.value), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString(_unref(translate)('hotelList.printDetail')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})